import "./logoutButton.scss";

const LogoutButton = ({ text, logout }: any) => (
    <div className="logout-button">
        <button
            type={"button"}
            className={"usp-bar__item"}
            onClick={(e) => {
                e.preventDefault();
                logout();
            }}
        >
            <div className="usp-bar__item-icon ">
                <i className="las la-undo" />
            </div>
            <div className="usp-bar__item-description body-copy-1">{text}</div>
        </button>
    </div>
);

export default LogoutButton;
